import { Timestamp } from 'firebase/firestore';
import { setDoc, doc } from 'firebase/firestore';

import {
  useCurrentUserGuid,
  useMessageCollection,
} from '../../../../firebase/useCollection';
import { MessageType } from '../../type';

export const useSendMessage = (
  channelGuid: string,
): ((
  guid: string,
  content: string,
  mediaInfo?: {
    mediaPath: string;
    mediaType: string;
    messageType: MessageType;
  },
) => void) => {
  const authorGuid = useCurrentUserGuid();
  const collection = useMessageCollection(channelGuid);
  return async (guid, content, mediaInfo) => {
    const messageType = mediaInfo?.messageType ?? 'TEXT';
    const message = {
      guid,
      channelGuid,
      authorGuid,
      content,
      messageType,
      createdDate: Timestamp.now(),
      ...(mediaInfo && { ...mediaInfo, scanStatus: 'NOT_STARTED' }),
    };
    await setDoc(doc(collection, message.guid), message);
  };
};
